






























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  JinroRoomDocument,
  JinroGamePlayinfoDocument,
  JinroPlayerStatisticsDocument,
} from "@/services/datatypes";
import { db, firestore } from "@/scripts/firebase";
import { collectionName } from "../../../services/collection-name";
import DeleteJinroPlayer from "@/components/JinroPlayer/Ending/DeleteJinroPlayer.vue";
import JinroStatisticsTable from "@/components/shared/JinroStatisticsTable.vue";
import { WhoWinsGame } from "../../../services/who-wins-game";
import { JinroPlayStatus } from "../../../services/jinro-play-status";
import { JinroRoles } from "../../../services/jinro-roles";
import { JinroTeamRoles } from "../../../services/jinro-team-roles";
import JinroGameHistoryDetail from "@/components/shared/JinroGameHistoryDetail/JinroGameHistoryDetail.vue";

@Component({
  components: {
    DeleteJinroPlayer,
    JinroStatisticsTable,
    JinroGameHistoryDetail,
  },
})
export default class Ending extends Vue {
  @Prop() readonly jinroPlayinfo!: JinroGamePlayinfoDocument;
  jinroRoomId = "";
  jinroRoomTitle = "";
  jinroRoomOwner = '"';
  timeLastGameEnded:
    | firebase.firestore.Timestamp
    | firebase.firestore.FieldValue
    | null = null;
  playersStatistics: Array<JinroPlayerStatisticsDocument> = [];
  detacher?: firebase.Unsubscribe;

  get jinroGameId(): string | null {
    if (!this.$store.state.jinroGame) {
      return null;
    }
    const jinroGameId = this.$store.state.jinroGame.id;
    return jinroGameId;
  }

  get isPublicViewing(): boolean {
    // public view path example:  /j/TAYBteCF9uJnFVyUtP8W/public
    const elmnts = this.$route.path.split("/");

    return elmnts.length > 3 && this.$route.path.split("/")[3] === "public";
  }

  get selectedPlayerId(): string {
    return this.$route.params.jinroPlayerId;
  }

  get backLinkLabel(): string {
    return `「${this.jinroRoomTitle}」に戻る`;
  }

  get gameResultInfo(): string {
    let text = this.defaultTxt + this.gameResult;
    if (this.youWinOrYouLose) {
      text += " (" + this.youWinOrYouLose + ")";
    }

    return text;
  }

  get youWinOrYouLose(): string {
    if (!this.$store.state.jinroGame) {
      return "";
    }
    if (!this.$store.state.jinroPlayerGame) {
      return "";
    }
    const role: JinroRoles = this.$store.state.jinroPlayerGame.role;
    const whoWinsGame = this.$store.state.jinroGame.whoWinsGame;
    const playerTeam: WhoWinsGame = JinroTeamRoles.includes(role)
      ? WhoWinsGame.JinroTeam
      : WhoWinsGame.MurabitoTeam;

    return playerTeam === whoWinsGame ? "YOU WIN" : "YOU LOSE";
  }

  get defaultTxt(): string {
    if (!this.$store.state.jinroGame) {
      return "";
    }
    let plsts = "";
    const playStatus = this.$store.state.jinroGame.currentPlayStatus;
    const dayN = this.$store.state.jinroGame.currentDayN;
    if (playStatus === JinroPlayStatus.Execution) {
      plsts = "処刑";
    }
    if (playStatus === JinroPlayStatus.Night) {
      plsts = "夜";
    }
    return `${dayN}日目  ${plsts} `;
  }

  get gameResult(): string {
    if (!this.$store.state.jinroGame) {
      return "";
    }

    if (this.$store.state.jinroGame.whoWinsGame === WhoWinsGame.JinroTeam) {
      return "人狼陣営の勝利";
    }
    if (this.$store.state.jinroGame.whoWinsGame === WhoWinsGame.MurabitoTeam) {
      return "村人陣営の勝利";
    }

    return "-";
  }

  get whoWinsGame(): WhoWinsGame | null {
    if (!this.$store.state.jinroGame) {
      return null;
    }
    return this.$store.state.jinroGame.whoWinsGame;
  }

  get isOwner() {
    return (
      this.$store.state.firebaseUser &&
      this.jinroRoomOwner === this.$store.state.firebaseUser.uid
    );
  }
  async created() {
    if (!this.$store.state.jinroGame) {
      return;
    }
    const ref = db
      .collection(collectionName.jinrorooms)
      .doc(this.$store.state.jinroGame.jinroRoomId);
    this.detacher = ref.onSnapshot((snapshot) => {
      const data = snapshot.data() as JinroRoomDocument;
      this.jinroRoomTitle = data.title;
      this.jinroRoomOwner = data.owner;
      this.jinroRoomId = snapshot.id;
      this.playersStatistics = data.jinroRoomPlayersStatistics
        ? data.jinroRoomPlayersStatistics
        : [];
      this.timeLastGameEnded = data.timeLastGameEnded
        ? data.timeLastGameEnded
        : null;
    });
  }
  destroyed() {
    this.detacher && this.detacher();
  }
}
